// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcp_a bhh_b bhh_uy bhh_rt bhh_ru bhh_vs","PanelFooter--link":"bcp_b"};